import { Component, Input, OnInit } from '@angular/core';
import { ChatService } from '../../../services/chat.service';

@Component({
  selector: 'app-chat-room',
  templateUrl: './chat-room.component.html',
  styleUrls: ['./chat-room.component.scss']
})
export class ChatRoomComponent implements OnInit {
  @Input() status: 'online' | 'offline';
  @Input() chatId: number;
  @Input() title: string;
  @Input() text: string;
  @Input() date: Date;
  @Input() isNew: boolean;
  @Input() avatar: string = '';
  @Input() active = false;
  constructor() { }

  ngOnInit(): void {
  }

}
